import Vue from 'vue';
import store from '@/stores'

//暂时此部分不使用
const Message = function (component, options, callback) {
  if (Vue.prototype.$isServer) return;
  options = options || {};
  var MsgComponent = Vue.extend(component);//定义组件
  var instance = new MsgComponent({ data: options });//初始化组件
  instance.$mount();//空挂载
  document.body.appendChild(instance.$el);//DOM挂载

  instance.callback = (action, inst) => {
    callback(action, inst);
  };
  return instance;
};

//alert
Message.alert = (options) => {
  if (typeof options == 'string') {
    var text = options;
    options = {}
    options.text = text;
  }
  options.type = "alert"
  options.title = "提示";
  options.width = 400;

  store.dispatch("message/options", options);
  store.dispatch("message/show", "alert");
};

//confirm
Message.confirm = (options, callback) => {
  if (typeof options == 'string') {
    var text = options;
    options = {}
    options.text = text;
  }
  options.type = "confirm"
  options.title = options.title ? options.title : "提示";
  options.width = 400;
  options.callback = callback;

  store.dispatch("message/options", options);
  store.dispatch("message/show", "confirm");
};

//prompt
Message.prompt = (options, callback) => {
  if (typeof options == 'string') {
    var text = options;
    options = {}
    options.text = text;
  }
  options.type = "prompt"
  options.title = "提示";
  options.width = 450;
  options.callback = callback;

  store.dispatch("message/options", options);
  store.dispatch("message/show", "prompt");
};

//loading
Message.loading = {
  show: () => {
    store.dispatch("message/show", "loading");
  },
  hide: () => {
    store.dispatch("message/hide", "loading");
  }
};

//toast
Message.toast = function (text, options) {
  options = options || {}
  options.text = text;
  options.type = "toast"
  options.title = "通知";

  options.top = ("top" in options) || true;
  options.left = ("left" in options) || false;
  options.right = ("right" in options) || false;
  options.bottom = ("bottom" in options) || false;

  options.timeout = ("timeout" in options) ? options.timeout : 3000;
  options.color = ("color" in options) ? options.color : "grey darken-4";

  store.dispatch("message/options", options);
  store.dispatch("message/show", "toast");
};

export default Message;
//https://cloud.tencent.com/developer/article/1148424
